import {Component, Input, OnInit} from '@angular/core';
import {Asset} from '../../shared/domain/item';
import {AssetSellingDetails} from "../../shared/domain/item/asset-selling-details.model";
import {appConfig} from "../../shared/app.config";

@Component({
  selector: 'lib-item-summary-asset-selling-details',
  templateUrl: './asset-selling-details.component.html',
  styleUrls: ['./asset-selling-details.component.scss']
})
export class AssetSellingDetailsComponent implements OnInit {

  @Input() asset: Asset;
  rbAsset: boolean;
  mpeAsset: boolean;
  featuredAsset: boolean;
  sellingDetails: AssetSellingDetails;
  dateTimeFormat: string;
  eventTitle: string;

  ngOnInit(): void {
    this.mpeAsset = this.asset.isMPEAsset();
    this.rbAsset = this.asset.isRBAsset();
    this.featuredAsset = !this.mpeAsset && !this.rbAsset;
    this.sellingDetails = this.asset.sellingDetails;
    this.dateTimeFormat = appConfig.timeFormatWithSeconds;
    this.eventTitle = this.getEventTitle(this.sellingDetails.saleNumber, this.sellingDetails.auctionEventName);
  }

  openEventDashboard() {
    window.open(this.asset.getEventDashboardUrl(), '_blank');
  }

  showRing() {
    return (this.asset.sequenced && this.rbAsset) || this.featuredAsset;
  }

  showRingType() {
    return this.rbAsset;
  }

  showStartTime() {
    return this.mpeAsset || this.featuredAsset;
  }

  showClosingTime() {
    return this.showStartTime() || (this.asset.sequenced && this.asset.talLot);
  }

  getEventTitle(saleNumber: string, auctionEventName: string) {
    return saleNumber ? `${saleNumber} - ${auctionEventName}`: auctionEventName;
  }

}
